module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0039.jpg?v=05c3adf0";